"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "UserIssueSk", {
    enumerable: true,
    get: function() {
        return UserIssueSk;
    }
});
const _lit = require("lit");
const _decorators = require("lit/decorators.js");
const _aloginsk = require("../../../infra-sk/modules/alogin-sk/alogin-sk");
const _anomaly = require("../common/anomaly");
require("../window/window");
const _errorMessage = require("../errorMessage");
require("../../../elements-sk/modules/icons/close-icon-sk");
require("../../../elements-sk/modules/icons/check-icon-sk");
const _jsonOrThrow = require("../../../infra-sk/modules/jsonOrThrow");
const _dataservice = require("../data-service/data-service");
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
var _UserIssueSk;
let UserIssueSk = (_UserIssueSk = class UserIssueSk extends _lit.LitElement {
    connectedCallback() {
        super.connectedCallback();
        if (this.user_id === '') {
            (0, _aloginsk.LoggedIn)().then((status)=>{
                this.user_id = status.email;
            });
        }
    }
    updated(changedProperties) {
        super.updated(changedProperties);
        if (changedProperties.has('trace_key') || changedProperties.has('commit_position') || changedProperties.has('begin_commit_position') || changedProperties.has('end_commit_position')) {
            this.loadExistingIssues();
        }
    }
    render() {
        if (this.bug_id === -1) {
            return (0, _lit.html)``;
        }
        const template = this.issueExists && this.user_id !== '' ? this.showLinkTemplate() : this.addIssueTemplate();
        if (this.user_id === '') {
            return template;
        }
        return (0, _lit.html)`
      ${template}
      <dialog id="loading-popup">
        <p>Creating a new bug. Waiting...</p>
      </dialog>
    `;
    }
    // If a bug is already associated with the data point show them the link.
    // The delete action for this bug will only be shown if the user is logged in.
    showLinkTemplate() {
        if (this.user_id === '') {
            return (0, _lit.html)`
        <div class="showLinkContainer">
          <span class="label">Bug:</span>
          <span class="linkContainer"> ${(0, _anomaly.formatBug)(window.perf.bug_host_url, this.bug_id)} </span>
        </div>
      `;
        }
        return (0, _lit.html)`
      <div class="showLinkContainer">
        <span class="label">Bug:</span>
        <span class="linkContainer">
          ${(0, _anomaly.formatBug)(window.perf.bug_host_url, this.bug_id)}
          <close-icon-sk @click=${this.removeIssue} ?hidden=${this.bug_id === 0}> </close-icon-sk>
        </span>
      </div>
    `;
    }
    changeHandler(e) {
        this._input_val = +e.target.value;
    }
    activateTextInput() {
        this._text_input_active = true;
        this.render();
    }
    hideTextInput() {
        this._input_val = 0;
        this._text_input_active = false;
        this.render();
    }
    async loadExistingIssues() {
        if (!this.trace_key || this.bug_id === -1) {
            return;
        }
        const begin = this.begin_commit_position || this.commit_position;
        const end = this.end_commit_position || this.commit_position;
        const req = {
            trace_keys: [
                this.trace_key
            ],
            begin_commit_position: begin,
            end_commit_position: end
        };
        const currentTraceKey = this.trace_key;
        const currentCommitPosition = this.commit_position;
        // Synchronously clear stale UI state before an async fetch
        this._existing_issues = [];
        if (this.bug_id !== -1) {
            this.bug_id = 0;
        }
        this.issueExists = false;
        try {
            const resp = await _dataservice.DataService.getInstance().getUserIssues(req);
            if (this.trace_key !== currentTraceKey || this.commit_position !== currentCommitPosition) {
                return; // Stale request
            }
            this._existing_issues = resp.UserIssues || [];
            const exactMatch = this._existing_issues.find((issue)=>issue.CommitPosition === this.commit_position);
            if (exactMatch) {
                this.bug_id = exactMatch.IssueId;
                this.issueExists = true;
            } else {
                this.bug_id = 0;
                this.issueExists = false;
            }
        } catch (e) {
            console.error('Failed to fetch existing issues.', e);
            if (this.trace_key === currentTraceKey && this.commit_position === currentCommitPosition) {
                this._existing_issues = [];
                if (this.bug_id !== -1) {
                    this.bug_id = 0;
                }
                this.issueExists = false;
            }
        }
    }
    selectIssue(issueId) {
        this._input_val = issueId;
        this.saveExistingIssue();
    }
    /* Templates */ // Template for showing option to add an issue on the datapoint
    // Only shown when the user is logged in
    addIssueTemplate() {
        if (this.user_id === '') {
            return (0, _lit.html)``;
        }
        if (this._text_input_active) {
            return (0, _lit.html)`
        <div class="new-issue-text-container">
          <span class="new-issue">
            <input
              style="width: 100px;"
              placeholder="eg: 3368155"
              type="number"
              min="0"
              @input=${this.changeHandler} />
          </span>
          <span>
            <check-icon-sk
              id="check-icon"
              @click=${()=>{
                this.saveExistingIssue();
            }}></check-icon-sk>
            <close-icon-sk @click=${this.hideTextInput}></close-icon-sk>
          </span>
        </div>
      `;
        }
        return (0, _lit.html)`
      ${this._existing_issues.length > 0 ? (0, _lit.html)`
            <ul class="issues-list">
              ${this._existing_issues.map((issue)=>(0, _lit.html)`
                  <li class="issue-item">
                    <div class="issue-info">
                      <span class="issue-id">Bug ID: ${issue.IssueId}</span>
                      <span class="issue-commit">Commit: ${issue.CommitPosition}</span>
                    </div>
                    <button @click=${()=>this.selectIssue(issue.IssueId)}>Select</button>
                  </li>
                `)}
            </ul>
          ` : (0, _lit.html)``}
      <div class="add-issue-container">
        <button class="add-issue" @click=${this.activateTextInput}>Existing issue</button>
        <button class="add-issue" @click=${this.createNewBug}>New Issue</button>
      </div>
    `;
    }
    /* API CALLS */ // Makes an api call to create a new buganizer issue if the bug not exists for the trace key
    async createNewBug() {
        this._loadingPopup.showModal();
        const body = {
            trace_key: this.trace_key,
            commit_position: this.commit_position,
            assignee: this.user_id
        };
        try {
            const resp = await fetch('/_/user_issue/create', {
                method: 'POST',
                body: JSON.stringify(body),
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            const json = await (0, _jsonOrThrow.jsonOrThrow)(resp);
            this._loadingPopup.close();
            // Open the bug page in new window.
            const bugUrl = `https://issues.chromium.org/issues/${json.bug_id}`;
            window.open(bugUrl, '_blank');
            this.bug_id = json.bug_id;
            this.issueExists = true;
            this.dispatchEvent(new CustomEvent('user-issue-changed', {
                detail: {
                    trace_key: this.trace_key,
                    commit_position: this.commit_position,
                    bug_id: this.bug_id
                },
                bubbles: true
            }));
        } catch (e) {
            this._loadingPopup.close();
            (0, _errorMessage.errorMessage)('File new bug request failed due to an internal server error. Please try again.');
            throw e;
        }
    }
    // Makes an api call to delete a buganizer issue
    // Also emits an event to refresh the existing list of user issues
    // with the newly deleted object.
    async removeIssue() {
        const traceKey = this.trace_key;
        const commitPosition = this.commit_position;
        const req = {
            trace_key: traceKey,
            commit_position: commitPosition
        };
        const resp = await fetch('/_/user_issue/delete', {
            method: 'POST',
            body: JSON.stringify(req),
            headers: {
                'Content-Type': 'application/json'
            }
        });
        if (!resp.ok) {
            const msg = await resp.text();
            (0, _errorMessage.errorMessage)(`${resp.statusText}: ${msg}`);
            return;
        }
        // Since the bug is deleted now, we set the bug_id to 0 for showing the
        // Add buganizer issue template
        this.bug_id = 0;
        this.issueExists = false;
        this._input_val = 0;
        this._text_input_active = false;
        this.dispatchEvent(new CustomEvent('user-issue-changed', {
            detail: {
                trace_key: this.trace_key,
                commit_position: this.commit_position,
                bug_id: this.bug_id
            },
            bubbles: true
        }));
    }
    // Makes an api call to save a buganizer issue
    // Also emits an event to refresh the existing list of user issues
    // with the newly added object.
    async saveIssue() {
        const traceKey = this.trace_key;
        const commitPosition = this.commit_position;
        const saveIssueRequest = {
            trace_key: traceKey,
            commit_position: commitPosition,
            issue_id: this.bug_id
        };
        const saveUserIssueResp = await fetch('/_/user_issue/save', {
            method: 'POST',
            body: JSON.stringify(saveIssueRequest),
            headers: {
                'Content-Type': 'application/json'
            }
        });
        if (!saveUserIssueResp.ok) {
            const msg = await saveUserIssueResp.text();
            (0, _errorMessage.errorMessage)(`${saveUserIssueResp.statusText}: ${msg}`);
            return;
        }
        this._input_val = 0;
        this._text_input_active = false;
        this.dispatchEvent(new CustomEvent('user-issue-changed', {
            detail: {
                trace_key: this.trace_key,
                commit_position: this.commit_position,
                bug_id: this.bug_id
            },
            bubbles: true
        }));
    }
    async saveExistingIssue() {
        this.bug_id = this._input_val;
        this.issueExists = true;
        await this.saveIssue();
    }
    constructor(...args){
        super(...args);
        // Email of the logged in user. Empty string otherwise
        this.user_id = '';
        // bug_id = 0 signifies no buganizer issue available in the database for the
        // data point. bug_id > 0 means we have an existing buganizer issue.
        // bug_id = -1 signifies the component is completely disabled and hidden.
        this.bug_id = 0;
        // The trace_key of the selected data point. Format: ,a=1,b=2,c=3,
        this.trace_key = '';
        // Commit position of the data point
        this.commit_position = 0;
        this.begin_commit_position = 0;
        this.end_commit_position = 0;
        this.issueExists = false;
        this._existing_issues = [];
        // Used for capturing number input values
        this._input_val = 0;
        // Indicates if the text input is active typically when adding a new issue.
        this._text_input_active = false;
    }
}, (()=>{
    _UserIssueSk.styles = (0, _lit.css)`
    .showLinkContainer {
      display: flex;
      align-items: center;

      .label {
        text-decoration: underline;
      }

      .linkContainer {
        color: var(--primary);
        font-size: 14px;
        display: flex;
        align-items: center;

        a {
          color: var(--primary);
          margin: 0 8px;
        }

        close-icon-sk {
          fill: var(--negative);
          cursor: pointer;
          height: 24px;
          width: 24px;
        }
      }
    }

    .new-issue-text-container {
      display: flex;
      align-items: center;
      padding-top: 25px;
      flex-direction: column;

      .new-issue {
        input {
          color: var(--on-surface);
          background: var(--surface);
          border: solid 1px var(--on-surface);
        }

        span {
          margin-left: 12px;

          check-icon-sk {
            fill: var(--positive);
            cursor: pointer;
            height: 24px;
            width: 24px;
          }

          close-icon-sk {
            fill: var(--negative);
            cursor: pointer;
            height: 24px;
            width: 24px;
          }
        }
      }
    }

    .new-issue-label {
      background: none !important;
      border: none;
      padding: 0 !important;
      color: var(--primary);
      text-decoration: underline;
      cursor: pointer;
      font-size: 14px;
    }

    .add-issue {
      align-items: center;
      background: transparent;
      border-radius: 4px;
      border: solid 1px var(--outline);
      box-shadow: none;
      color: var(--primary);
      display: inline-flex;
      fill: var(--primary);
      font-size: 11px;
      height: 24px;
      justify-content: center;
      margin: 0 2px;
      min-width: auto;
      padding: 0 4px;
      text-align: center;
      text-transform: none;
      white-space: nowrap;
      cursor: pointer;

      &:hover {
        background: var(--surface-1dp);
      }

      .icon-sk {
        font-size: 20px;
      }

      svg {
        width: 20px;
        height: 20px;
      }
    }

    .add-issue-container {
      display: flex;
      flex-flow: row nowrap;
      align-items: center;
      gap: 4px;
    }

    .issues-list {
      margin: 8px 0;
      padding: 0;
      list-style: none;

      .issue-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 8px;
        background: var(--surface-1dp);
        border: 1px solid var(--outline);
        border-radius: 4px;
        margin-bottom: 4px;

        .issue-info {
          display: flex;
          flex-direction: column;
          gap: 2px;
          margin-right: 8px;

          .issue-id {
            font-weight: bold;
            color: var(--primary);
          }

          .issue-commit {
            font-size: 0.85rem;
            color: var(--on-surface-variant);
          }
        }

        button {
          background: transparent;
          color: var(--primary);
          border: 1px solid var(--primary);
          border-radius: 4px;
          padding: 4px 8px;
          cursor: pointer;
          transition: background-color 0.2s;

          &:hover {
            background: var(--primary-variant);
            color: var(--on-primary);
          }
        }
      }
    }
  `;
})(), _UserIssueSk);
_ts_decorate([
    (0, _decorators.property)({
        attribute: true
    }),
    _ts_metadata("design:type", String)
], UserIssueSk.prototype, "user_id", void 0);
_ts_decorate([
    (0, _decorators.property)({
        type: Number,
        attribute: true
    }),
    _ts_metadata("design:type", Number)
], UserIssueSk.prototype, "bug_id", void 0);
_ts_decorate([
    (0, _decorators.property)({
        attribute: true
    }),
    _ts_metadata("design:type", String)
], UserIssueSk.prototype, "trace_key", void 0);
_ts_decorate([
    (0, _decorators.property)({
        type: Number,
        attribute: true
    }),
    _ts_metadata("design:type", Number)
], UserIssueSk.prototype, "commit_position", void 0);
_ts_decorate([
    (0, _decorators.property)({
        type: Number,
        attribute: true
    }),
    _ts_metadata("design:type", Number)
], UserIssueSk.prototype, "begin_commit_position", void 0);
_ts_decorate([
    (0, _decorators.property)({
        type: Number,
        attribute: true
    }),
    _ts_metadata("design:type", Number)
], UserIssueSk.prototype, "end_commit_position", void 0);
_ts_decorate([
    (0, _decorators.state)()
], UserIssueSk.prototype, "issueExists", void 0);
_ts_decorate([
    (0, _decorators.state)(),
    _ts_metadata("design:type", Array)
], UserIssueSk.prototype, "_existing_issues", void 0);
_ts_decorate([
    (0, _decorators.property)({
        attribute: false
    }),
    _ts_metadata("design:type", Boolean)
], UserIssueSk.prototype, "_text_input_active", void 0);
_ts_decorate([
    (0, _decorators.query)('#loading-popup'),
    _ts_metadata("design:type", typeof HTMLDialogElement === "undefined" ? Object : HTMLDialogElement)
], UserIssueSk.prototype, "_loadingPopup", void 0);
UserIssueSk = _ts_decorate([
    (0, _decorators.customElement)('user-issue-sk')
], UserIssueSk);
